import React from 'react';
import { IonCol, IonRow, IonButton } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { colorTheme } from '../../utils/constants';
import { Card } from '@tremor/react';

const PropertiesSummaryCard = (props) => {
    let history = useHistory();

    return (
        <Card className='p-3' key={props.header}>
            <p className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
              {props.header}
            </p>
            <div className="mt-2 flex items-baseline space-x-2.5">
              <p className="text-tremor-metric font-semibold text-tremor-content-strong dark:text-dark-tremor-content-strong">
                {props.body}
              </p>
            </div>
            <p className="mt-1 text-tremor-default text-tremor-content dark:text-dark-tremor-content">
              {props.footer}
            </p>

          </Card>

    )
}

export default PropertiesSummaryCard;
